/**
 * Widget Configuration Schema
 * 
 * DEPRECATED: This file is maintained for backward compatibility.
 * New code should import from './config' instead.
 * 
 * @example
 * // Old way (still works):
 * import { getDefaultConfig, getDefaultSizes, transformWidgetData } from './widgetConfigSchema';
 * 
 * // New way (preferred):
 * import { getDefaultConfig, getDefaultSizes, transformWidgetData } from './config';
 */

// Import from new modular config (must be at top)
import { widgetDefaults } from './config/defaults';
import { widgetSizes } from './config/sizes';
import { widgetPropSchema } from './config/validation';
import { dataTransformers } from './config/dataTransformers';

// Re-export everything from the new modular config
export {
// Constants
  DATE_FORMATS,
  LEGEND_POSITIONS,
  VALUE_FORMATS,
  DEFAULT_FALLBACK_SIZES,
  DEFAULT_FALLBACK_DATA,
  GROUPING_FIELDS,
  
  // Defaults
  widgetDefaults,
  getDefaultConfig,
  
  // Sizes
  widgetSizes,
  getDefaultSizes,
  
  // Validation
  validateWidgetConfig,
  widgetPropSchema,
  getRequiredProps,
  getOptionalProps,
  
  // Data Transformers
  transformWidgetData,
  dataTransformers,
  extractDataFromApiResponse,
  normalizeGroupingField,
  extractTimeValue,
  extractMeasureValue,
  safeDataMapping
} from './config';

/**
 * Legacy widget configuration schema
 * Combines defaults, sizes, props, and data mapping for each widget type
 * @deprecated Use individual exports from './config' instead
 */
const widgetConfigSchema = {};

// Build schema from individual modules
const widgetTypes = Object.keys(widgetDefaults);
for (const type of widgetTypes) {
  widgetConfigSchema[type] = {
    requiredProps: widgetPropSchema[type]?.requiredProps || [],
    optionalProps: widgetPropSchema[type]?.optionalProps || [],
    defaultConfig: widgetDefaults[type] || {},
    dataMapping: dataTransformers[type] || ((data) => data),
    defaultSizes: widgetSizes[type] || {}
  };
}

export default widgetConfigSchema;
